import { StoryblokRichtext } from '@definitions/types/storyblokBaseTypes'

/**
 * Creates a mock StoryblokRichtext
 * @param text - Optional text content
 * @returns Complete StoryblokRichtext mock
 */
export function createStoryblokRichtext(text: string = 'Lorem ipsum'): StoryblokRichtext {
  return {
    type: 'doc',
    content: [
      {
        type: 'paragraph',
        content: [
          {
            text,
            type: 'text',
          },
        ],
      },
    ],
  }
}
